import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalLoginComponent } from 'src/app/components/modals/modal-login/modal-login.component';

@Component({
  standalone: false,
  selector: 'app-admin-modal-confirm',
  templateUrl: './admin-modal-confirm.component.html',
  styleUrls: ['./admin-modal-confirm.component.scss'],
})
export class AdminModalConfirmComponent {

  constructor(
    public dialogRef: MatDialogRef<ModalLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }


  close(accept?: boolean) {
    this.dialogRef.close(accept);
  }

}
